import { BackspaceOutlined, Check, Done, DoneAll } from "@mui/icons-material";
import { deepmerge } from "@mui/utils";
import {
  ListItemIcon,
  Menu,
  MenuItem,
  Stack,
  useTheme,
  Checkbox,
  Popover,
  Box,
  Button,
  Typography,
  TextField,
  createTheme,
  ThemeProvider,
  Autocomplete,
  Tooltip,
  Divider,
  MenuList,
  alpha,
} from "@mui/material";
import useStyles from "./styles";
import {
  DateCalendar,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { VirtualizedListbox } from "../../easyMaps/vitualizationAutoComplete";

const ModalVerify = ({
  anchorEl,
  setAnchorEl,
  options = [],
  selected,
  setSelected = () => {},
  setChange = () => {},
}) => {
  const handleClose = (status) => {
    setAnchorEl(null);
    if (status || status == "") {
      setSelected(status);
    }
    setChange(true);
  };
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={() => handleClose()}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      sx={styles.paperPoover}
    >
      <MenuItem
        key={"nulo"}
        selected={selected == ""}
        onClick={() => handleClose("")}
      >
        <Stack sx={{ ml: "-5px", mr: "5px" }}>
          <Checkbox sx={styles.checkBox} checked={selected === ""} />
        </Stack>
        Nenhum
      </MenuItem>

      {Object.keys(options).map((option) => (
        <MenuItem
          key={option}
          onClick={() => handleClose(option)}
          selected={selected === option}
        >
          <Stack sx={{ ml: "-5px", mr: "5px" }}>
            <Checkbox sx={styles.checkBox} checked={selected === option} />
          </Stack>

          {options[option]}
        </MenuItem>
      ))}
    </Menu>
  );
};
const ModalAutoComplete = ({
  anchorEl,
  setAnchorEl,
  selected,
  setSelected = () => {},
  setChange = () => {},
  options = [],
  title = "",
  type = "text",
}) => {
  const handleClose = () => {
    setAnchorEl(null);
  };

  const theme = useTheme();
  const styles = useStyles(theme);
  // textFiel par informar a porta
  return (
    <Popover
      id={"modal-data"}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      inert={!Boolean(anchorEl)}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      sx={styles.paperPoover}
    >
      <Stack
        direction="row"
        alignItems={"center"}
        gap={1}
        justifyContent={"space-between"}
      >
        <Typography sx={styles.textDataPicker}>{title}</Typography>

        <Autocomplete
          disablePortal
          options={options}
          value={selected}
          ListboxComponent={VirtualizedListbox}
          getOptionLabel={(option) => String(option)}
          onChange={(event, newValue) => {
            setSelected(newValue);
            setChange(true);
          }}
          renderOption={(props, option, { selected }) => (
            <li {...props} style={{ padding: "0px" }} key={option.itemid}>
              <Stack sx={styles.stackOption}>
                <Checkbox checked={selected} />
                <span style={styles.textoLimitado}>{option}</span>
              </Stack>{" "}
            </li>
          )}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} />}
        />
      </Stack>
    </Popover>
  );
};
const ModalTextField = ({
  anchorEl,
  setAnchorEl,
  selected,
  setSelected = () => {},
  setChange = () => {},

  title = "",
  type = "text",
}) => {
  const handleClose = () => {
    setAnchorEl(null);
  };

  const theme = useTheme();
  const styles = useStyles(theme);
  // textFiel par informar a porta
  return (
    <Popover
      id={"modal-data"}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      inert={!Boolean(anchorEl)}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      sx={styles.paperPoover}
    >
      <Stack
        direction="row"
        alignItems={"center"}
        gap={1}
        justifyContent={"space-between"}
      >
        <Typography sx={styles.textDataPicker}>{title}</Typography>

        <TextField
          type={type}
          autoComplete="off"
          value={selected}
          onChange={(event) => {
            setSelected(event.target.value);
            setChange(true);
          }}
          sx={styles.textField}
        />
      </Stack>
    </Popover>
  );
};

export { ModalVerify, ModalTextField, ModalAutoComplete };
